<h2 mat-dialog-title>Terms and Conditions</h2>

<mat-dialog-content>
  <div class="terms-content">
    <p>
      By submitting, I confirm the address provided is correct and authorize SimpleBills to mail my refund check (if eligible) to this address or, if selected, to the alternate recipient I have indicated.
    </p>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onClose()">Close</button>
</mat-dialog-actions>
